import { render, staticRenderFns } from "./RatesLayout.vue?vue&type=template&id=365d1f27&scoped=true&"
import script from "./RatesLayout.vue?vue&type=script&lang=js&"
export * from "./RatesLayout.vue?vue&type=script&lang=js&"
import style0 from "./RatesLayout.vue?vue&type=style&index=0&id=365d1f27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365d1f27",
  null
  
)

export default component.exports